angular.module('lf.common')

.factory('productsService', function ($http) {
  var productDetailUrl = lf.data.xhr.productDetail;
  
  return {
    get: get
  }
  
  /**
   * Get product data (json)
   * 
   * @param {Object} params {id: string, [skuId: string]}
   * @returns {Promise}
   */
  
  function get (params) {
    return $http.get(productDetailUrl + '?' + $.param(params));
  }
});
